import { CatalogueService } from './../../services/catalogue.service';
// TODO: This component will be relocated to the left side bar.

import { Component, OnInit, HostBinding, Injector, Inject } from '@angular/core';
import { slideToRight } from '../../shared/animations.collections';
import { CreateEventService } from '../../nav/shared/createevent.listener';
import { Router, ActivatedRoute } from '@angular/router';
import { MyAccountService } from '../../services/myAccount.service';
import { AuthService } from '../../services/auth.service';
import { CommonService } from '../../services';
import { ApiResponse } from '../../models/api-response.model';
import { CurrentUserModel, UsersViewModel, ActiveUserViewModel, UserInfoViewModel } from '../../models/account-ledger.model';
import { DOCUMENT } from '@angular/common';
import { NewsletterService } from '../../services/newsletter.service';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.css'],
  animations: [slideToRight('100%')]
})
export class DeleteSubscriptionsComponent implements OnInit {
  @HostBinding('@slideToRight') ani;
  loadContent = false;

  activeUser: ActiveUserViewModel;
  checkedPromotions: boolean;
  checkedDatafeedsCsv: boolean;
  title = 'My Subscriptions';
  usersList: ActiveUserViewModel[];

  currentUserModel: CurrentUserModel;

  userInfo: UserInfoViewModel;

  accountId: string;
  loginName: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  adminChecked: boolean;
  purchaseChecked: boolean;
  checkedDatafeedsXml: boolean;
  checkedOrderConfirmations: boolean;
  checkedInvoices: boolean;
  checkedOrderStatusUpdates: boolean;
  checkedBackorderETAUpdates: boolean;
  checkedAnnuityExpiryNotifications: boolean;
  checkedShippingReports: boolean;
  checkedStatements: boolean;
  downloadLink = '';
  checkDatafeedXML: boolean;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private pageService: CreateEventService,
    private router: Router,
    private myAccountService: MyAccountService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private catalogueService: CatalogueService,
    private commonService: CommonService,
    private newsletterService: NewsletterService) {}

  ngOnInit() {

    this.loadContent = false;
    // get login user information
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;

      // get users list subscription information
      this.myAccountService.GetUsers().subscribe((data: UsersViewModel) => {
        if (data && data.activeUsers.length) {
          this.usersList = data.activeUsers;

          // get login user subscriptions information
          // tslint:disable-next-line:no-shadowed-variable
          this.usersList.forEach(element => {
            if (element.loginName.toLowerCase() === this.currentUserModel.loginId.toLowerCase()) {
              this.activeUser = element;

              this.checkedPromotions = this.activeUser.promotions.toLowerCase() === 'y' ? true : false;
              this.checkedDatafeedsCsv = this.activeUser.datafeedCSV.toLowerCase() === 'y' ? true : false;
              this.checkDatafeedXML = this.activeUser.datafeedXML.toLocaleLowerCase() === 'y' ? true : false;
              this.loadContent = true;
            }
          });
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    });
  }

  update(): void {
    this.loadContent = false;
    this.userInfo = {
      loginName: this.activeUser.loginName,
      accountId: '',
      firstName: this.activeUser.firstName,
      lastName: this.activeUser.lastName,
      email: this.activeUser.email,
      password: this.activeUser.newPassword,
      roles: '',
      mfaEnabled: '',
      isAdmin: this.adminChecked,
      isPurchaseOfficer: this.purchaseChecked,
      promotions: this.checkedPromotions,
      dataFeed: this.checkedDatafeedsCsv,
      stockCatalogue: this.checkedDatafeedsXml,
      invoices: this.checkedInvoices,
      orderConfs: this.checkedOrderConfirmations,
      orderStatusUpdates: this.checkedOrderStatusUpdates,
      etaUpdates: this.checkedBackorderETAUpdates,
      annuityExpireUpdates: this.checkedAnnuityExpiryNotifications,
      shippingReports: this.checkedShippingReports,
      statements: this.checkedStatements
    };
    this.myAccountService.UpdateUserProfile(this.userInfo).subscribe((res: ApiResponse) => {
      if (res.status) {
        // this.commonService.showValidator(".update", res.responseMessage, "right", "success");
        this.commonService.implementToast(res.responseMessage, 'Success');
      } else {
        // this.commonService.showValidator(".update", res.responseMessage, "right", "error");
        this.commonService.implementToast(res.responseMessage, 'Error');
      }
      this.loadContent = true;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
    this.loadContent = true;

  }

  //#region OLD DATAFEED FUNCTIONS

  downloadDatafeeds() {
    this.commonService.implementToast('Datafeeds CSV will be downloaded shortly', 'Info');
     this.catalogueService.getDataFeedDownloadLink().subscribe((res: string) => {
         if (res) {
           this.downloadLink = res;
           window.location.href = this.downloadLink;
         }
     },
     (error: any) => {
       console.error(error);
       this.commonService.implementToast('Download Datafeeds CSV failed', 'Error');
     });
  }

  copyDatafeedsLink() {
    this.catalogueService.getDataFeedDownloadLink().subscribe((res: string) => {
      if (res) {
        const downloadURL = document.location.protocol + '//' + document.location.hostname + res;
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast('Datafeeds CSV download link copied to clipboard successfully', 'Success');

      }
    },
    (error: any) => {
      console.error(error);
      this.commonService.implementToast('Get Datafeeds CSV download url failed', 'Error');
    });
  }

  downloadJSONDatafeeds() {
    this.commonService.implementToast('Datafeeds JSON will be downloaded shortly', 'Info');
     this.catalogueService.getDataFeedJSONDownloadLink().subscribe((res: string) => {
         if (res) {
           this.downloadLink = res;
           window.location.href = this.downloadLink;
         }
     },
     (error: any) => {
       console.error(error);
       this.commonService.implementToast('Download Datafeeds JSON failed', 'Error');
     });
  }

  copyJSONDatafeedsLink() {
    this.catalogueService.getDataFeedJSONDownloadLink().subscribe((res: string) => {
      if (res) {
        const downloadURL = document.location.protocol + '//' + document.location.hostname + res;
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast('Datafeeds JSON download link copied to clipboard successfully', 'Success');
      }
    },
    (error: any) => {
      console.error(error);
      this.commonService.implementToast('Get Datafeeds JSON download url failed', 'Error');
    });
  }

  //#endregion

  //#region NEW DATAFEED LOCATION

  downloadDatafeeds_SQL() {
    this.commonService.implementToast('Datafeeds CSV will be downloaded shortly', 'Info');
     this.newsletterService.getDataFeedDownloadLink().subscribe((res: string) => {
         if (res) {
           this.downloadLink = res;
           window.location.href = this.downloadLink;
         }
     },
     (error: any) => {
       console.error(error);
       this.commonService.implementToast('Download Datafeeds CSV failed', 'Error');
     });
  }

  copyDatafeedsLink_SQL() {
    this.newsletterService.getDataFeedDownloadLink().subscribe((res: string) => {
      if (res) {
        const downloadURL = document.location.protocol + '//' + document.location.hostname + res;
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast('Datafeeds CSV download link copied to clipboard successfully', 'Success');

      }
    },
    (error: any) => {
      console.error(error);
      this.commonService.implementToast('Get Datafeeds CSV download url failed', 'Error');
    });
  }

  downloadJSONDatafeeds_SQL() {
    this.commonService.implementToast('Datafeeds JSON will be downloaded shortly', 'Info');
     this.newsletterService.getDataFeedJSONDownloadLink().subscribe((res: string) => {
         if (res) {
           this.downloadLink = res;
           window.location.href = this.downloadLink;
         }
     },
     (error: any) => {
       console.error(error);
       this.commonService.implementToast('Download Datafeeds JSON failed', 'Error');
     });
  }

  copyJSONDatafeedsLink_SQL() {
    this.newsletterService.getDataFeedJSONDownloadLink().subscribe((res: string) => {
      if (res) {
        const downloadURL = document.location.protocol + '//' + document.location.hostname + res;
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast('Datafeeds JSON download link copied to clipboard successfully', 'Success');
      }
    },
    (error: any) => {
      console.error(error);
      this.commonService.implementToast('Get Datafeeds JSON download url failed', 'Error');
    });
  }


  //#endregion

  downloadXMLDatafeeds() {
    this.commonService.implementToast('Datafeeds XML will be downloaded shortly', 'Info');
     this.catalogueService.getDataFeedXMLDownloadLink().subscribe((res: string) => {
         if (res) {
           this.downloadLink = res;
           window.location.href = this.downloadLink;
         }
     },
     (error: any) => {
       console.error(error);
       this.commonService.implementToast('Download Datafeeds XML failed', 'Error');
     });
  }

  copyXMLDatafeedsLink() {
    this.catalogueService.getDataFeedXMLDownloadLink().subscribe((res: string) => {
      if (res) {
        const downloadURL = document.location.protocol + '//' + document.location.hostname + res;
        console.log(downloadURL);
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast('Datafeeds XML download link copied to clipboard successfully', 'Success');
      }
    },
    (error: any) => {
      console.error(error);
      this.commonService.implementToast('Get Datafeeds XML download url failed', 'Error');
    });
  }

  copyToClipboard(item: any): void {
    const listener = (e: ClipboardEvent) => {
        e.clipboardData.setData('text/plain', (item));
        e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  closePage() {

    this.pageService.destoryComponent('person');
  }
}
